"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const linkview_align_parser_1 = __importStar(require("@linkview/linkview-align-parser"));
const error_1 = require("../../utils/error");
function assignAlignmentsByCtgs(target, source) {
    for (let ctg1 in source) {
        if (!(ctg1 in target)) {
            target[ctg1] = source[ctg1];
        }
        else {
            for (let ctg2 in source[ctg1]) {
                if (!(ctg2 in target[ctg1])) {
                    target[ctg1][ctg2] = source[ctg1][ctg2];
                }
                else {
                    target[ctg1][ctg2].push(...source[ctg1][ctg2]);
                }
            }
        }
    }
}
function alignCreater() {
    return __awaiter(this, void 0, void 0, function* () {
        const options = this;
        const { inputs, inputContent, min_alignment_length: minAlignmentLength, min_identity: minIdentity, min_bit_score: minBitScore, max_evalue: maxEvalue, layout } = options;
        const lenInfoAll = {};
        const alignmentsAll = [];
        const alignmentsByCtgsAll = {};
        if (inputs) {
            for (let input of inputs) {
                const { alignments, lenInfo, alignmentsByCtgs } = yield (0, linkview_align_parser_1.default)(input, {
                    minIdentity,
                    minAlignmentLength,
                    maxEvalue,
                    minBitScore,
                    filterCtgPairs: [],
                });
                Object.assign(lenInfoAll, lenInfo);
                alignmentsAll.push(...alignments);
                assignAlignmentsByCtgs(alignmentsByCtgsAll, alignmentsByCtgs);
            }
        }
        else if (inputContent) {
            const { alignments, lenInfo, alignmentsByCtgs } = (0, linkview_align_parser_1.alignParserFromContent)(inputContent, {
                minIdentity,
                minAlignmentLength,
                maxEvalue,
                minBitScore,
                filterCtgPairs: [],
            });
            Object.assign(lenInfoAll, lenInfo);
            alignmentsAll.push(...alignments);
            assignAlignmentsByCtgs(alignmentsByCtgsAll, alignmentsByCtgs);
        }
        options.alignments = alignmentsAll;
        options.lenInfo = lenInfoAll;
        options.alignmentsByCtgs = alignmentsByCtgsAll;
        for (let index = 0, levelCount = layout.length; index < levelCount; index++) {
            const layoutLineBefore = layout[index - 1];
            const layoutLineCur = layout[index];
            const layoutLineNext = layout[index + 1];
            layoutLineCur.forEach((layoutItemCur) => {
                const ctgsWithNoInfo = new Set();
                const layoutItemsWithNoInfo = new Set();
                const intervalInfoByAlignments = {};
                const setIntervalInfo = (ctg, start, end) => {
                    const min = Math.min(start, end);
                    const max = Math.max(start, end);
                    if (!(ctg in intervalInfoByAlignments))
                        intervalInfoByAlignments[ctg] = { start: min, end: max };
                    else {
                        intervalInfoByAlignments[ctg] = {
                            start: Math.min(min, intervalInfoByAlignments[ctg].start),
                            end: Math.max(max, intervalInfoByAlignments[ctg].end),
                        };
                    }
                };
                layoutLineBefore && layoutLineBefore.forEach((layoutItemBefore) => {
                    const ctg1 = layoutItemCur.ctg;
                    const ctg2 = layoutItemBefore.ctg;
                    const { alignmentsByCtgs } = options;
                    if (layoutItemCur.start === 0 || layoutItemCur.end === 0) {
                        ctgsWithNoInfo.add(layoutItemCur.ctg);
                        layoutItemsWithNoInfo.add(layoutItemCur);
                    }
                    const alignments = ctg1 in alignmentsByCtgs
                        ? ctg2 in alignmentsByCtgs[ctg1]
                            ? alignmentsByCtgs[ctg1][ctg2]
                            : []
                        : [];
                    if (!alignments || alignments.length === 0)
                        return;
                    for (let index = 0, count = alignments.length; index < count; index++) {
                        const alignment = alignments[index];
                        const displayStart1 = layoutItemCur.ctg === alignment.ctg1 ? layoutItemCur.start : layoutItemBefore.start;
                        const displayEnd1 = layoutItemCur.ctg === alignment.ctg1 ? layoutItemCur.end : layoutItemBefore.end;
                        const displayStart2 = layoutItemCur.ctg === alignment.ctg2 ? layoutItemCur.start : layoutItemBefore.start;
                        const displayEnd2 = layoutItemCur.ctg === alignment.ctg2 ? layoutItemCur.end : layoutItemBefore.end;
                        const calculatedAlignment = (0, linkview_align_parser_1.calculateSubAlign)(alignment, displayStart1, displayEnd1, displayStart2, displayEnd2);
                        if (!calculatedAlignment)
                            continue;
                        const { ctg1, start1, end1, ctg2, start2, end2 } = calculatedAlignment;
                        const [startCur, endCur] = layoutItemCur.ctg === ctg1 ? [start1, end1] : [start2, end2];
                        setIntervalInfo(layoutItemCur.ctg, startCur, endCur);
                    }
                });
                layoutLineNext && layoutLineNext.forEach((layoutItemNext) => {
                    const ctg1 = layoutItemCur.ctg;
                    const ctg2 = layoutItemNext.ctg;
                    const { alignmentsByCtgs } = options;
                    if (layoutItemCur.start === 0 || layoutItemCur.end === 0) {
                        ctgsWithNoInfo.add(layoutItemCur.ctg);
                        layoutItemsWithNoInfo.add(layoutItemCur);
                    }
                    const alignments = ctg1 in alignmentsByCtgs
                        ? ctg2 in alignmentsByCtgs[ctg1]
                            ? alignmentsByCtgs[ctg1][ctg2]
                            : []
                        : [];
                    if (!alignments || alignments.length === 0)
                        return;
                    for (let index = 0, count = alignments.length; index < count; index++) {
                        const alignment = alignments[index];
                        const displayStart1 = layoutItemCur.ctg === alignment.ctg1 ? layoutItemCur.start : layoutItemNext.start;
                        const displayEnd1 = layoutItemCur.ctg === alignment.ctg1 ? layoutItemCur.end : layoutItemNext.end;
                        const displayStart2 = layoutItemCur.ctg === alignment.ctg2 ? layoutItemCur.start : layoutItemNext.start;
                        const displayEnd2 = layoutItemCur.ctg === alignment.ctg2 ? layoutItemCur.end : layoutItemNext.end;
                        const calculatedAlignment = (0, linkview_align_parser_1.calculateSubAlign)(alignment, displayStart1, displayEnd1, displayStart2, displayEnd2);
                        if (!calculatedAlignment)
                            continue;
                        const { ctg1, start1, end1, ctg2, start2, end2 } = calculatedAlignment;
                        const [startCur, endCur] = layoutItemCur.ctg === ctg1 ? [start1, end1] : [start2, end2];
                        setIntervalInfo(layoutItemCur.ctg, startCur, endCur);
                    }
                });
                for (let layoutItem of layoutItemsWithNoInfo) {
                    const { ctg } = layoutItem;
                    if (!intervalInfoByAlignments[ctg])
                        continue;
                    layoutItem.start = intervalInfoByAlignments[ctg].start;
                    layoutItem.end = intervalInfoByAlignments[ctg].end;
                    (0, error_1.warn)(`${ctg} lacks start and end information. It automatically calculates that start is ${layoutItem.start} and end is ${layoutItem.end}.`);
                }
            });
        }
        return options;
    });
}
exports.default = alignCreater;
